import React, { useState, useEffect } from 'react';
import { useSeo } from '../seo/useSeo';
import SEO_PAGES from '../seo/pages.json';
import { track } from '../analytics/track';

const GALLERIES = [
  {
    title: "Hannah and Gavin's Wedding",
    date: 'May 28, 2026',
    description: "Hannah and Gavin's Wedding — May 2026",
    thumbnail: '/20260528_205842_255_3600.jpg',
    embedSrc: 'https://fotoshare.co/e/S3vH9oxpzOewNSc4GBLt4?embed=1',
  },
];

const ClientGallery = () => {
  const [active, setActive] = useState(null);

  useSeo({ ...SEO_PAGES['/gallery'], canonicalPath: '/gallery' });

  useEffect(() => {
    document.body.style.overflow = active !== null ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [active]);

  return (
    <div className="client-gallery-page">
      <div className="client-gallery-header">
        <h1>Client Galleries</h1>
        <p>Browse photos from our recent events.</p>
      </div>

      <div className="client-gallery-grid">
        {GALLERIES.map((gallery, i) => (
          <button
            key={i}
            className="client-gallery-tile"
            onClick={() => {
              setActive(i);
              track('gallery_open', { gallery: gallery.title });
            }}
            style={{ backgroundImage: `url(${gallery.thumbnail})` }}
          >
            <div className="client-gallery-tile-overlay" />
            <div className="client-gallery-tile-content">
              <span className="client-gallery-tile-title">{gallery.title}</span>
              {gallery.date && <span className="client-gallery-tile-date">{gallery.date}</span>}
              <span className="client-gallery-tile-cta">View Gallery →</span>
            </div>
          </button>
        ))}
      </div>

      {active !== null && (
        <div className="client-gallery-modal" onClick={() => setActive(null)}>
          <div className="client-gallery-modal-inner" onClick={(e) => e.stopPropagation()}>
            <div className="client-gallery-modal-header">
              <span className="client-gallery-modal-title">{GALLERIES[active].description}</span>
              <button className="client-gallery-modal-close" onClick={() => setActive(null)} aria-label="Close">✕</button>
            </div>
            <iframe
              allow="web-share"
              src={GALLERIES[active].embedSrc}
              style={{ width: '100%', flex: 1, border: 0 }}
              frameBorder="0"
              title={GALLERIES[active].title}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientGallery;
